import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Bash = () => {
  return (
    <StartInterviewLayout type="bash"/>
  )
}

export default Bash;